/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Header_LogoutInputs */

const es_user_profile_header_logout = /** @type {(inputs: User_Profile_Header_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar Sesión`)
};

const en_user_profile_header_logout = /** @type {(inputs: User_Profile_Header_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logout`)
};

/**
* | output |
* | --- |
* | "Logout" |
*
* @param {User_Profile_Header_LogoutInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_header_logout = /** @type {((inputs?: User_Profile_Header_LogoutInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Header_LogoutInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_header_logout(inputs)
	return en_user_profile_header_logout(inputs)
});
export { user_profile_header_logout as "user.profile.header.logout" }